import "./Footer.css";
import footerLogoPastoral from "../../assets/images/footerLogoPastoral.webp";
import footerLogoMumulya from "../../assets/images/footerLogoMumulya.webp";
import footerLogoMolokomarket from "../../assets/images/footerLogoMolokomarket.webp";
import fbIcon from "../../assets/icons/fbIcon.png";
import instIcon from "../../assets/icons/instIcon.png";
import ttIcon from "../../assets/icons/ttIcon.png";
import { useLocation } from "react-router-dom";

const texts = {
  ua: {
    copyright: "copyright 2025 — pastoral.ua. Всі права захищені.",
  },
  ru: {
    copyright: "copyright 2025 — pastoral.ua. Все права защищены.",
  },
};

const Footer = () => {
  const location = useLocation()
  const currentLang = location.pathname.startsWith("/ru") ? "ru" : "ua";
  const t = texts[currentLang];
  return (
    <footer className="footer">
      <div className="footer__wrapper">
        <div className="footer-first">
          <div className="footer-logos">
            <img
              src={footerLogoPastoral}
              alt="логотип пасторал"
              className="footer-logo"
            />
            <img
              src={footerLogoMumulya}
              alt="логотип мумуля"
              className="footer-logo"
            />
            <img
              src={footerLogoMolokomarket}
              alt="логотип молокомаркет"
              className="footer-logo"
            />
          </div>
          <div className="footer-social">
            <a
              href="https://www.facebook.com/share/1JhN5KFqfM/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={fbIcon}
                alt="иконка фейсбук"
                className="footer-social-icon"
              />
            </a>
            <a
              href="https://www.instagram.com/pastoral_1?igsh=ZWZsOHZzZ2VuZ2p1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={instIcon}
                alt="иконка инстаграм"
                className="footer-social-icon"
              />
            </a>
            <a
              href="https://www.tiktok.com/@pastoral0589?_t=ZM-906UinI671E&_r=1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={ttIcon}
                alt="иконка тикток"
                className="footer-social-icon"
              />
            </a>
          </div>
        </div>
        <div className="footer-second"></div>
      </div>
      <div className="footer__border"></div>
      <div className="footer__wrapper">
        <div className="footer__copyright mont-m">
          {t.copyright}
        </div>
        <div className="footer__contacts">
          <a className="footer__contact int-r" href="tel:+38(066) 444-55-33">
            +38(066) 444-55-33
          </a>
          <a
            className="footer__contact int-r"
            href="mailto:officemanager.dmsz@gmail.com"
          >
            officemanager.dmsz@gmail.com
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
